import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
	KngFooter,
	KngFooterCopyRightLabel,
	KngFooterData,
	KngFooterState,
	FooterLabel
} from './definitions/footer.interface';
import { KngFooterFactory } from './kng-footer.factory';
import { KngFooterService } from './kng-footer.service';
import { get as lodashGet } from 'lodash';
import { isRaymond } from '../../constants/environment.constant';
@Component({
	selector: 'kng-footer',
	templateUrl: './template/kng-footer.component.html',
	styleUrls: ['./template/kng-footer.component.scss']
})
export class KngFooterComponent implements KngFooter, OnInit
{
	isRaymond:boolean = false;
	private state$: BehaviorSubject<KngFooterState> =
		new BehaviorSubject<KngFooterState>(KngFooterFactory.buildState());
  @Input() set state(value: KngFooterState)
	{
		this.state$.next(value);
		this.footerdata = value;
		this.footercontent = value.footercontent;
	}
  footerdata: KngFooterState = KngFooterFactory.buildState();
  footerLabel = FooterLabel;
  footercontent!: KngFooterData;
  @Output() ctaLinkClicked: EventEmitter<KngFooterState> =
  	new EventEmitter<KngFooterState>();
  @Output() languageSelectionChanged: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('dropdown', { read: ElementRef }) dropdown!: ElementRef;
  get state(): KngFooterState
  {
  	return this.state$.value;
  }

  get isActionFooterPresent(): boolean
  {
  	return this.footerService.isActionFooterPresent;
  }

  constructor(private footerService: KngFooterService, private renderer2: Renderer2) {}

  ngOnInit(): void
  {
  	this.isRaymond = isRaymond || false;
  	if(this.isRaymond) 
  	{
	 const ele: HTMLElement = this.renderer2.selectRootElement('html', true);
	 let value = ele.getAttribute('lang');
	 if(value)
	 {
		 setTimeout(() =>
		 {
			 if(this.dropdown)
			 {
				 value = this.languageCheck(value);
				 this.dropdown.nativeElement.value = value;
			 }
		 }, 1000);
	 }
  	}
  }

  languageCheck(value: string | null): string
  {
	 if(value && value === 'fr')
	 {
		 return 'French';
	 }
	 else
	 {
		 return 'United States- English';
	 }
  }


  public ctaLinkClick(element: KngFooterCopyRightLabel): void
  {
  	if (element.url)
  	{
  		window.open(element.url, '_blank');
  	}
  }
  public updateLanguageSelection(event: Event): void
  {
  	this.languageSelectionChanged.emit(lodashGet(event, 'target.value'));
  }
  public navigateTologo()
  {
  	window.open('https://www.toyotaforklift.com/', '_blank', 'noopener');
  }
  navigateto(url: string | undefined)
  {
  	const currentData = {
  		urlOfOrigin: window.location.href,
  		email: ''
  	};
  	const userProfile = localStorage.getItem('userDetails');
  	if(userProfile)
  	{
  		const user = JSON.parse(userProfile);
  		currentData.email = user.email;
  	}
  	const currentPath = btoa(JSON.stringify(currentData));
  	window.open(`${url}?metadata=${currentPath}`, '_blank', 'noopener');
  }

  handleTelClick(event: MouseEvent) 
  {
  	if(!this.isMobile() || !isRaymond) 
  	{
  		event.preventDefault(); 
  	}
  }
 
  isMobile(): boolean 
  {
  	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
}
